import type {DriverScanResult, OverallProblemIndicators} from "../scan-model/ScanResult.tsx";
import Styles from "./ScanResultDisplay.module.scss"
import type {PythonProblemIndicator} from "../scan-operations/job/ProblemIndicators.ts";
import {distinct} from "../../../util/distinct.ts";

function PythonProblemIndicatorDisplay({python}: {python: PythonProblemIndicator | undefined}) {
    if(python == undefined) return null
    const interpreters = python.interpreters.sort().filter(distinct())
    return <div className={Styles.PythonBlock}>
        Python:
        <span>Interpreters: {interpreters.join(", ")}</span>
        <span>Uses Cursor: {python.usesCursor ? "Yes" : "No"}</span>
        <span>Imports: {python.quickImportScan.join(", ")}</span>
    </div>
}

export interface ProblematicDisplayProps {
    problems: OverallProblemIndicators,
    drivers?: DriverScanResult
}

export function ProblematicDisplay({problems, drivers}: ProblematicDisplayProps) {
    const { python, gridExportComponents, sharedJobCount, databaseTypeCount, databaseTypeConnectionOptions } = problems
    return <div className={Styles.ProblematicDisplay}>
        <PythonProblemIndicatorDisplay python={python} />
        <div>Grid Export Components: {gridExportComponents}</div>
        {Object.keys(sharedJobCount).length > 0 && <div className={Styles.SharedJobBlock}>Shared Jobs:
            {Object.keys(sharedJobCount).map(k => <div key={k}>
                {k} - {sharedJobCount[k]}
            </div>)}
        </div>}
        {Object.keys(databaseTypeCount).length > 0 && <div className={Styles.DBQueryBlock}>Database Types:
            {Object.keys(databaseTypeCount).map(k => <div key={k}>
                {k} - {databaseTypeCount[k]} - [{(databaseTypeConnectionOptions[k] ?? []).join(", ")}]
            </div>)}
        </div>}
        {drivers && <div>Driver Groups With Files: {drivers.driverGroups.join(", ")}</div>}
    </div>
}